import React from 'react';

export const FilterFunnelIcon = ({
  width = '40',
  height = '40',
  color = '#3966E0',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M36.6668 5H3.3335L16.6668 20.7667V31.6667L23.3335 35V20.7667L36.6668 5Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
